import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AriticleForm from "../components/form/AriticleForm"
import useAuth from "../hooks/useAuth";
import { usePage } from "../contexts/PageProvider";
import axios from "../utils/axios";
import { UPDATE_ARTICLE_URL } from '../contexts/PageProvider';
import {useNotifications} from 'reapop';

const submitUrl = '/article'


const UpdateAritclePage = () => {
  const { pageData, setPageData } = usePage();
  const {notify} = useNotifications();

  if (pageData.url != UPDATE_ARTICLE_URL) {
      setPageData({url: UPDATE_ARTICLE_URL, title: "Fiche article"});      
  }
  
  const {auth} = useAuth();
  const userId = auth?.user?.id
  
  const urlParams = useParams();
  
  const [initialValues, setInitialValues] = useState(null)
  const formValues = {
    owner: userId,
    title: '',
    description: '',
    tags: '',
    image: '',
    content: '',
    is_active: false,
    display: [],
    group: ''
  };
  
  const transformArticleResponse = (article) => {
    if (article?.display) {
      article.display = article?.display?.split(',');
    }

    if (article?.group) {
      article.group = article?.group?.id;
    }

    return article;
  }

  const onSubmit = async (values, {resetForm, setErrors, setSubmitting}) => {
    if (values.image) {
      values.image = typeof values.image !== 'string' ? JSON.stringify(values.image) : values.image // the image data is saved as a string
    }
    if (values.image_slider) {
      values.image_slider = typeof values.image_slider !== 'string' ? JSON.stringify(values.image_slider) : values.image_slider // the image_slider data is saved as a string
    }    
    values.display = values.display.join(',')
    
    try {
        const response = await axios.patch(`${submitUrl}/${urlParams?.id}`, values);
        const result = transformArticleResponse(response.data);
        setInitialValues(result);
        notify('Article modifié avec succès', 'info', {dismissAfter: 5000});
    } catch (error) {
        setErrors({createError: error.message})
        console.error(error)
    }
  };   

  useEffect(() => {
      (async () => {
          try {
              const response = await axios.get(`${submitUrl}/${urlParams?.id}`);
              const result = transformArticleResponse(response.data);
              setInitialValues(result);
          } catch (error) {
              console.error(error.message);
              setInitialValues(formValues);
          }
      })()
  }, []);


  return (
    <>
      {
        initialValues &&
          <AriticleForm {...{initialValues, onSubmit, submitButtonChildren: 'Envoyer'}} />
      }
    </>
  )
}

export default UpdateAritclePage;